/** Mirrors `CinData\Enum\OrderState`. */
export enum OrderStateEnum {
    PENDING = 'pending',
    FULFILLED = 'fulfilled',
    ORPHANED = 'orphaned',
    REFUNDED = 'refunded',
    CANCELED = 'canceled',
    /** The payment system canceled the payment, e.g. because the seat locks expired. */
    CANCELED_BY_PAYMENT_SYSTEM = 'canceled_by_payment_system',
    /** Fulfilled, then the payment failed after all (bank or fraud check); needs manual triage. */
    PAYMENT_FAILED_AFTER_FULFILLMENT = 'payment_failed_after_fulfillment',
    /** Paid, but the booking could not be completed (seats, or the ticket system refused); refunded in full. */
    REFUNDED_FULFILLMENT_FAILED = 'refunded_fulfillment_failed'
}
